import { render, staticRenderFns } from "./newsForm.vue?vue&type=template&id=2068239f"
import script from "./newsForm.vue?vue&type=script&lang=js"
export * from "./newsForm.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports